import { initSurvey } from "../../store/survey/actions";
import store from "../../store";

export default function responderSurvey(conversationId, questionMain, pendingSurveyId, active) {
  store.dispatch(initSurvey(conversationId, questionMain, pendingSurveyId, active));
}
